export default "__VITE_ASSET__DQKF0LWQ__"